import { gql } from '@apollo/client';

export const GET_PRICE_CHANGE_REQUEST = gql(/* GraphQL */ `
    query GetPriceChangeRequest($id: String!) {
        getPriceChangeRequest(id: $id) {
            id
            friendlyId
            latestStatus
            completed
            previousSellingPrice
            previousCostPrice
            cashbuildPrice
            pnlPrice
            changedPriceValidFrom
            changedPriceValidTo
            completed
            competitor {
                id
                address
                email
                name
                store {
                    id
                    name
                }
                telNo {
                    number
                    countryCode
                    dialingCode
                }
            }
            competitorPrice
            createdAt
            product {
                id
                effectiveSellingPrice
                currentSellingPrice
                sellingPriceCurrency
                sellingPriceValidFrom
                sellingPriceValidTo
                currentCostPrice
                costPriceCurrency
                costPriceValidFrom
                costPriceValidTo
                description
                category {
                    id
                    name
                    benchmarkMargin
                }
                sku
                status
            }
            storeId
            isFromPriceSurvey
            priceChangeScope
            suggestedStoreIds
            advertisingZone {
                id
                name
            }
            store {
                id
                salesOrgId
                advertisingZoneId
                isTradingAsCashbuild
                advertisingZone {
                    name
                    stores {
                        id
                        name
                        town
                        storeNo
                        isClosed
                        isTradingAsCashbuild
                    }
                }
            }
            proofOfCompetitorPricing {
                id
                competitorId
                details {
                    fileType
                    fileName
                    fileExtension
                    fileSize
                }
                documentS3Path
                type
                downloadUrl
            }
            proposedPrice
            proposedValidFrom
            declinedReason
            reasonForChange
            salesDataRequestStatus
            salesDataRequestedAt
            store {
                id
                name
                town
                storeNo
            }
            temporaryChangedPrice
            temporaryCashbuildPrice
            temporaryPnlPrice
            temporaryChangedPriceValidFrom
            temporaryChangedPriceValidTo
            temporaryChangeReason
            previousCashbuildPrice
            previousPnlPrice
            priceChangeRequestActions {
                id
                action
                createdAt
                dueBy
                possibleOutcomes
                completed
                responsibleUser {
                    id
                    firstName
                    lastName
                }
                priceChangeRequestStatus {
                    id
                    createdAt
                    status
                    note
                }
            }
            sapPriceChangeRequests {
                id
                storeNo
                outcome
                outcomeReason
                isInterim
                isFromRelatedSkus
                sku
            }
        }
    }
`);

export const GET_PRICE_CHANGE_REQUESTS_TABLE_DATA = gql(/* GraphQL */ `
    query GetPriceChangeRequestsTableData($input: FilterInput!) {
        getPriceChangeRequestsTableData(filterInput: $input) {
            requests {
                id
                friendlyId
                latestStatus
                createdAt
                completed
                completedAt
                currentPrice
                currentPriceCurrency
                proposedPrice
                proposedPriceCurrency
                currentMargin
                proposedMargin
                benchmarkMargin
                resolvedVatPercentage
                dueBy
                sapOutcome
                storeNo
                salesOrgId
                storeName
                productSku
                productDescription
                productCategory
                reasonForChange
                declinedReason
                temporaryChangeReason
                cashbuildPrice
                pnlPrice
                previousCashbuildPrice
                previousPnlPrice
                changedPriceValidFrom
                changedPriceValidTo
                temporaryChangedPrice
                temporaryCashbuildPrice
                temporaryPnlPrice
                temporaryChangedPriceValidFrom
                temporaryChangedPriceValidTo
                advertisingZoneName
                advertisingZoneId
                procurementManager {
                    firstName
                    lastName
                }
                isUrgent
                isAutoDeclined
                storeId
                productId
                previousSellingPrice
                previousCostPrice
                proposedValidFrom
                currency
                competitorPrice
                costPrice
                zoneHighestCostPrice
                cashbuildCostPrice
                pnlCostPrice
                storeCostPrice
                isFromPriceSurvey
                priceChangeScope
                suggestedStoreIds
                hasFuturePrice
                priceSurveyType
                priceSurveyLabel
                salesTrend
                storeSalesTrend
                zoneSalesTrend
            }
            pagination {
                skip
                take
                total
            }
            statusCounts {
                totalActive
                approved
                declined
                inProgress
            }
        }
    }
`);
export const GET_PRICE_CHANGE_REQUEST_BATCHES_TABLE_DATA = gql(/* GraphQL */ `
    query GetPriceChangeRequestBatchesTableData($input: FilterInput!) {
        getPriceChangeRequestBatchesTableData(filterInput: $input) {
            batches {
                batchId
                requestCount
                earliestCreatedAt
                advertisingZone {
                    id
                    name
                }
                competitor {
                    id
                    name
                    address
                    email
                    telNo {
                        countryCode
                        dialingCode
                        number
                    }
                }
                proofOfCompetitorPricing {
                    id
                    competitorId
                    type
                    documentS3Path
                    downloadUrl
                    details {
                        fileType
                        fileMimeType
                        fileName
                        fileExtension
                        fileSize
                    }
                }
                requests {
                    id
                    friendlyId
                    latestStatus
                    createdAt
                    completed
                    completedAt
                    currentPrice
                    currentPriceCurrency
                    proposedPrice
                    proposedPriceCurrency
                    currentMargin
                    proposedMargin
                    benchmarkMargin
                    resolvedVatPercentage
                    dueBy
                    sapOutcome
                    storeNo
                    salesOrgId
                    storeName
                    productSku
                    productDescription
                    productCategory
                    reasonForChange
                    declinedReason
                    temporaryChangeReason
                    cashbuildPrice
                    pnlPrice
                    previousCashbuildPrice
                    previousPnlPrice
                    changedPriceValidFrom
                    changedPriceValidTo
                    temporaryChangedPrice
                    temporaryCashbuildPrice
                    temporaryPnlPrice
                    temporaryChangedPriceValidFrom
                    temporaryChangedPriceValidTo
                    advertisingZoneName
                    advertisingZoneId
                    procurementManager {
                        firstName
                        lastName
                    }
                    isUrgent
                    isAutoDeclined
                    storeId
                    productId
                    previousSellingPrice
                    previousCostPrice
                    proposedValidFrom
                    currency
                    competitorPrice
                    costPrice
                    zoneHighestCostPrice
                    cashbuildCostPrice
                    pnlCostPrice
                    storeCostPrice
                    isFromPriceSurvey
                    priceChangeScope
                    suggestedStoreIds
                    priceSurveyType
                    priceSurveyLabel
                    batchId
                    hasFuturePrice
                    salesTrend
                    storeSalesTrend
                    zoneSalesTrend
                    store {
                        id
                        name
                        town
                        storeNo
                        salesOrgId
                        isTradingAsCashbuild
                        isClosed
                        productAvailability {
                            isLive
                            costPrice
                            currency
                        }
                    }
                    priceChangeRequestActions {
                        id
                        action
                        completed
                        possibleOutcomes
                        responsibleUser {
                            id
                        }
                    }
                }
            }
            pagination {
                skip
                take
                total
            }
        }
    }
`);

export const GET_PRICE_CHANGE_REQUESTS_FOR_BATCH = gql(/* GraphQL */ `
    query GetPriceChangeRequestsForBatch(
        $batchId: String!
        $input: FilterInput!
    ) {
        getPriceChangeRequestsForBatch(batchId: $batchId, filterInput: $input) {
            id
            friendlyId
            latestStatus
            createdAt
            completed
            completedAt
            currentPrice
            currentPriceCurrency
            proposedPrice
            proposedPriceCurrency
            currentMargin
            proposedMargin
            benchmarkMargin
            resolvedVatPercentage
            dueBy
            sapOutcome
            storeNo
            salesOrgId
            storeName
            productSku
            productDescription
            productCategory
            reasonForChange
            declinedReason
            temporaryChangeReason
            cashbuildPrice
            pnlPrice
            previousCashbuildPrice
            previousPnlPrice
            changedPriceValidFrom
            changedPriceValidTo
            temporaryChangedPrice
            temporaryCashbuildPrice
            temporaryPnlPrice
            temporaryChangedPriceValidFrom
            temporaryChangedPriceValidTo
            advertisingZoneName
            advertisingZoneId
            procurementManager {
                firstName
                lastName
            }
            isUrgent
            isAutoDeclined
            storeId
            productId
            previousSellingPrice
            previousCostPrice
            proposedValidFrom
            currency
            competitorPrice
            costPrice
            zoneHighestCostPrice
            cashbuildCostPrice
            pnlCostPrice
            storeCostPrice
            isFromPriceSurvey
            priceChangeScope
            suggestedStoreIds
            priceSurveyType
            priceSurveyLabel
            batchId
            hasFuturePrice
            salesTrend
            storeSalesTrend
            zoneSalesTrend
            store {
                id
                name
                town
                storeNo
                salesOrgId
                isTradingAsCashbuild
                isClosed
                productAvailability {
                    isLive
                    costPrice
                    currency
                }
            }
            priceChangeRequestActions {
                id
                action
                completed
                possibleOutcomes
                responsibleUser {
                    id
                }
            }
        }
    }
`);

export const GET_STATUS_COUNTS = gql(/* GraphQL */ `
    query GetPriceChangeRequestStatusCounts($input: StatsFilterInputDto!) {
        getPriceChangeRequestStatusCounts(filterInput: $input) {
            totalRequests
            newRequests
            actionedRequests
            inProgressRequests
            pendingRequests
            supplierNegotiationRequests
        }
    }
`);

export const GET_CATEGORY_STATS = gql(/* GraphQL */ `
    query GetPriceChangeRequestCategoryStats($input: StatsFilterInputDto!) {
        getPriceChangeRequestCategoryStats(filterInput: $input) {
            requestsPerCategory {
                category {
                    id
                    name
                }
                decreaseRequests
                increaseRequests
                totalRequests
            }
            increasedRequests
            decreasedRequests
        }
    }
`);
export const GET_ACTIONS = gql(/* GraphQL */ `
    query GetPriceChangeRequestActions(
        $responsibleUserIds: [String!]!
        $onlyUncompletedActions: Boolean!
    ) {
        getPriceChangeRequestActions(
            responsibleUserIds: $responsibleUserIds
            onlyUncompletedActions: $onlyUncompletedActions
        ) {
            id
            action
            completed
            dueBy
            priceChangeRequest {
                id
                proposedPrice
                product {
                    id
                    description
                    sku
                    category {
                        name
                    }
                }
                store {
                    name
                    storeNo
                }
            }
            responsibleUser {
                id
                firstName
                lastName
            }
        }
    }
`);

export const GET_PRICE_CHANGE_REQUEST_HISTORY = gql(/* GraphQL */ `
    query GetPriceChangeRequestHistory($id: String!) {
        getPriceChangeRequestHistory(id: $id) {
            history {
                actionId
                date
                dueBy
                status
                title
                description
                reasonForChange
                declineReason
                note
                escalationMessage
                showEscalationBadge
                showPriceChangeFreezeBadge
                escalationEvents {
                    breachedByName
                    slaLabel
                    escalatedToName
                    escalatedToDesignation
                    escalatedAt
                    resolved
                    resolvedByName
                    resolvedAt
                }
                cashbuildPrice
                pnlPrice
                temporaryChangedPrice
                temporaryCashbuildPrice
                temporaryPnlPrice
                temporaryChangeReason
            }
        }
    }
`);

export const GET_REQUEST_ESCALATION_MESSAGE = gql(/* GraphQL */ `
    query GetRequestEscalationMessage($id: String!) {
        getPriceChangeRequestEscalated(id: $id) {
            message
        }
    }
`);
export const GET_PROOF_OF_COMPETITOR_PRICING = gql(/* GraphQL */ `
    query GetProofOfCompetitorPricing($ids: [String!]!) {
        getProofOfCompetitorPricing(ids: $ids) {
            id
            competitorId
            details {
                fileType
                fileName
                fileExtension
                fileSize
            }
            documentS3Path
            type
            downloadUrl
        }
    }
`);

export const SUGGEST_FRIENDLY_IDS = gql`
    query SuggestFriendlyIds($search: String!) {
        suggestFriendlyIds(search: $search)
    }
`;

export const SUGGEST_PRODUCT_SKUS = gql`
    query SuggestProductSkus($search: String!) {
        suggestProductSkus(search: $search)
    }
`;

export const GET_PRICE_CHANGE_REQUEST_TABLE_ROW = gql(/* GraphQL */ `
    query GetPriceChangeRequestTableRow($id: String!) {
        getPriceChangeRequestTableRow(id: $id) {
            id
            friendlyId
            latestStatus
            createdAt
            completed
            completedAt
            currentPrice
            currentPriceCurrency
            proposedPrice
            proposedPriceCurrency
            currentMargin
            proposedMargin
            benchmarkMargin
            resolvedVatPercentage
            dueBy
            sapOutcome
            storeNo
            salesOrgId
            storeName
            productSku
            productDescription
            productCategory
            reasonForChange
            declinedReason
            temporaryChangeReason
            cashbuildPrice
            pnlPrice
            previousCashbuildPrice
            previousPnlPrice
            changedPriceValidFrom
            changedPriceValidTo
            temporaryChangedPrice
            temporaryCashbuildPrice
            temporaryPnlPrice
            temporaryChangedPriceValidFrom
            temporaryChangedPriceValidTo
            advertisingZoneId
            advertisingZoneName
            procurementManager {
                firstName
                lastName
            }
            isUrgent
            isAutoDeclined
            isFromPriceSurvey
            priceChangeScope
            suggestedStoreIds
            storeId
            productId
            hasFuturePrice
            salesTrend
            storeSalesTrend
            zoneSalesTrend
            previousSellingPrice
            previousCostPrice
            proposedValidFrom
            currency
            competitorPrice
            costPrice
            zoneHighestCostPrice
            cashbuildCostPrice
            pnlCostPrice
            storeCostPrice
            isFromPriceSurvey
            priceSurveyType
            priceSurveyLabel
        }
    }
`);

export const GET_COMPETITOR_FOR_REQUEST = gql(/* GraphQL */ `
    query GetCompetitorForRequest($requestId: String!) {
        getCompetitorForRequest(requestId: $requestId) {
            id
            name
            address
            email
            telNo {
                number
                countryCode
                dialingCode
            }
            store {
                id
                name
            }
        }
    }
`);

export const GET_SAP_OUTCOMES_FOR_REQUEST = gql(/* GraphQL */ `
    query GetSapOutcomesForRequest($requestId: String!) {
        getSapOutcomesForRequest(requestId: $requestId) {
            id
            storeNo
            outcome
            outcomeReason
            isInterim
            isFromRelatedSkus
            sku
            price
            outcomePrice
        }
    }
`);

export const GET_SAP_CONFIRMED_PRICES_FOR_REQUEST = gql(/* GraphQL */ `
    query GetSapConfirmedPricesForRequest($id: String!) {
        getPriceChangeRequest(id: $id) {
            id
            sapConfirmedCashbuildPrice
            sapConfirmedPnlPrice
        }
    }
`);

export const GET_AD_ZONE_STORES_FOR_REQUEST = gql(/* GraphQL */ `
    query GetAdZoneStoresForRequest($requestId: String!, $productSku: String) {
        getAdvertisingZoneStoresForRequest(requestId: $requestId) {
            id
            name
            town
            storeNo
            salesOrgId
            isTradingAsCashbuild
            isClosed
            productAvailability(sku: $productSku) {
                isLive
                costPrice
                currency
            }
            priceChangeRestriction {
                restrictionType
                reason
            }
        }
    }
`);

export const GET_PROOF_OF_PRICING_FOR_REQUEST = gql(/* GraphQL */ `
    query GetProofOfPricingForRequest($requestId: String!) {
        getProofOfPricingForRequest(requestId: $requestId) {
            id
            competitorId
            type
            downloadUrl
            details {
                fileType
                fileName
                fileExtension
                fileSize
            }
            documentS3Path
        }
    }
`);
